/* @flow */

import AdminNavigation from './AdminNavigation'
import Navigation from './Navigation'
import SettingsNavigation from './SettingsNavigation'

export default Navigation

export { AdminNavigation, SettingsNavigation }
